// extracted by mini-css-extract-plugin
export default {"container":"splashScreen_container__hY41C","slideUpSplash":"splashScreen_slideUpSplash__i7T8c","text":"splashScreen_text__IHVHT"};